import React from "react"

export function IosAdd({
  fill = "white",
  h = 18,
  w = 18,
  className = "",
}: {
  fill?: string
  h?: number
  w?: number
  className?: string
}) {
  return (
    <svg
      className={className}
      width={w}
      height={h}
      viewBox="0 0 683 683"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M106 41.3333C93.3333 44.6666 87.6 47.2 77.0667 54.1333C60.8 64.9333 50.2667 78.9333 43.0667 99.3333L39.3333 110V340.667C39.3333 600 38.4 576.133 49.4667 597.333C59.7333 617.067 77.7333 632.4 99.0667 639.6L110 643.333L336.933 643.733C590 644.133 573.867 644.667 594 634.8C617.733 623.2 633.2 605.067 641.067 579.6C643.067 573.333 643.333 550 643.6 345.733C644 148.4 643.733 117.467 642 109.067C639.467 96.6667 630 77.4666 621.867 68.2666C614.133 59.3333 599.467 48.9333 589.467 45.2C571.467 38.5333 578.533 38.6666 338.933 38.8C125.2 38.8 114.933 38.9333 106 41.3333ZM569.333 80.8C582.8 84.8 593.333 94 599.6 107.333L603.333 115.333L603.733 338.667C604 582 604.4 569.2 596.667 581.2C593.333 586.533 585.333 594.267 579.867 597.733C569.067 604.267 578.533 604 338 603.733L114 603.333L107.333 600C99.7333 596.267 89.3333 587.067 85.2 580.4C78.5333 569.6 78.6667 577.733 78.6667 340.533C78.6667 137.6 78.8 118.533 80.9333 112.533C86.1333 97.0667 97.8667 85.4666 112.8 80.8C118.533 79.0666 148.133 78.8 340.8 78.8C539.067 78.6666 562.933 78.9333 569.333 80.8Z"
        fill={fill}
      />
      <path
        d="M330.533 185.733C321.2 191.867 321.333 190.933 321.333 259.6V321.333H260C192.667 321.333 192.933 321.333 186.267 329.2C178.933 338 182.533 353.6 193.333 358.933C197.6 361.067 203.6 361.333 259.733 361.333H321.333V422.933C321.333 479.067 321.6 485.067 323.733 489.333C330.8 503.6 351.867 503.6 358.933 489.333C361.067 485.067 361.333 479.067 361.333 422.933V361.333H423.067C479.067 361.333 485.067 361.067 489.333 358.933C503.6 351.867 503.6 330.8 489.333 323.733C485.067 321.6 479.067 321.333 423.067 321.333H361.333V260C361.333 192.267 361.333 192.533 353.067 186.133C346.933 181.467 337.067 181.333 330.533 185.733Z"
        fill={fill}
      />
    </svg>
  )
}
